import getIn from 'immutable-less/transmute/getIn';
import UITruncateString from 'UIComponents/text/UITruncateString';
// @ts-expect-error untyped module
import ResolveReferences from 'reference-resolvers/ResolveReferences';
// @ts-expect-error untyped module
import { isError, isLoading, isResolved } from 'reference-resolvers/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const GenericEnrollmentTableCellView = ({
  object
}) => {
  if (isError(object) || isLoading(object)) {
    return null;
  }
  if (isResolved(object)) {
    const label = getIn(['label'], object.referencedObject);
    return /*#__PURE__*/_jsx(UITruncateString, {
      children: label
    });
  }
  return null;
};
const mapResolversToProps = (resolvers, props) => {
  return {
    object: resolvers[props.objectType].byId(props.id)
  };
};
const GenericEnrollmentTableCell = ResolveReferences(mapResolversToProps)(GenericEnrollmentTableCellView);
export default GenericEnrollmentTableCell;